import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import ProductListPagerClassicPaginationButton from './ProductListPagerClassicPaginationButton';
import ProductListPagerClassicPageList from './ProductListPagerClassicPageList';
import ProductListPagerClassicDots from './ProductListPagerClassicDots';
import ProductListPagerClassicArrow from './ProductListPagerClassicArrow';
import usePages from './usePages';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(0.5)
    },
    pageList: {
      display: 'flex',
      flexDirection: 'row',
      minWidth: theme.spacing(12),
      justifyContent: 'space-around'
    },
    'full-width': {
      flexGrow: function flexGrow(props) {
        return props.fullWidth ? 1 : 0;
      }
    },
    leftSide: {
      display: 'flex',
      flexDirection: 'row'
    },
    rightSide: {
      display: 'flex',
      flexDirection: 'row'
    },
    arrow: {
      padding: theme.spacing(0),
      minWidth: theme.spacing(3),
      minHeight: theme.spacing(4)
    },
    paginationButton: {
      padding: theme.spacing(0),
      minWidth: theme.spacing(3),
      minHeight: theme.spacing(4)
    },
    dots: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: theme.spacing(3),
      minHeight: theme.spacing(4)
    },
    sideButton: {
      padding: theme.spacing(0),
      minWidth: theme.spacing(3),
      minHeight: theme.spacing(4)
    }
  };
}, {
  name: 'SxComProductListPagerClassic'
});

function ProductListPagerClassic(_ref) {
  var pBackIconButtonProps = _ref.backIconButtonProps,
      _ref$buttonWidth = _ref.buttonWidth,
      buttonWidth = _ref$buttonWidth === void 0 ? 24 : _ref$buttonWidth,
      pClasses = _ref.classes,
      className = _ref.className,
      count = _ref.count,
      fullWidth = _ref.fullWidth,
      pNextIconButtonProps = _ref.nextIconButtonProps,
      onChangePage = _ref.onChangePage,
      page = _ref.page,
      _ref$pageListWidthPro = _ref.pageListWidthProp,
      pageListWidthProp = _ref$pageListWidthPro === void 0 ? 0 : _ref$pageListWidthPro,
      rest = _objectWithoutProperties(_ref, ["backIconButtonProps", "buttonWidth", "classes", "className", "count", "fullWidth", "nextIconButtonProps", "onChangePage", "page", "pageListWidthProp"]);

  var classes = useStyles({
    classes: pClasses,
    fullWidth: fullWidth
  });
  var buttonLeftArrowContent = React.useMemo(function () {
    return pBackIconButtonProps || '<';
  }, [pBackIconButtonProps]);
  var buttonRightArrowContent = React.useMemo(function () {
    return pNextIconButtonProps || '>';
  }, [pNextIconButtonProps]);

  var handleArrowClick = function handleArrowClick(direction) {
    return function () {
      if (direction === 'back') {
        onChangePage((page - 1 + count) % count);
      } else {
        onChangePage((page + 1) % count);
      }
    };
  };

  var _React$useState = React.useState(1024),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      pageListWidth = _React$useState2[0],
      setPageListWidth = _React$useState2[1];

  var getPageListWidth = function getPageListWidth(width) {
    if (pageListWidthProp > 0) {
      width = pageListWidthProp;
    }

    setPageListWidth(width);
  };

  var _usePages = usePages(count, page, pageListWidth, buttonWidth),
      lowerLimit = _usePages.lowerLimit,
      showFirstPage = _usePages.showFirstPage,
      showLastPage = _usePages.showLastPage,
      showNextDots = _usePages.showNextDots,
      showNextPage = _usePages.showNextPage,
      showPrevDots = _usePages.showPrevDots,
      showPrevPage = _usePages.showPrevPage,
      upperLimit = _usePages.upperLimit;

  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), count > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.leftSide
  }, showPrevPage === true ? /*#__PURE__*/React.createElement(ProductListPagerClassicArrow, {
    className: classes.arrow,
    onArrowClick: handleArrowClick('back'),
    buttonArrowContent: buttonLeftArrowContent
  }) : null, showFirstPage === true ? /*#__PURE__*/React.createElement(ProductListPagerClassicPaginationButton, {
    pageIndex: 0,
    onChangePage: onChangePage,
    currentPage: page,
    className: classes.sideButton,
    classes: {
      paginationButton: classes.paginationButton
    }
  }) : null, showPrevDots === true ? /*#__PURE__*/React.createElement(ProductListPagerClassicDots, {
    className: classes.dots
  }) : null), /*#__PURE__*/React.createElement(ProductListPagerClassicPageList, {
    lowerLimit: lowerLimit,
    upperLimit: upperLimit,
    onChangePage: onChangePage,
    page: page,
    getPageListWidth: getPageListWidth,
    className: clsx(classes.root, className, classes.pageList, classes["full-width"]),
    classes: {
      paginationButton: classes.paginationButton
    },
    fullWidth: fullWidth
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.rightSide
  }, showNextDots === true ? /*#__PURE__*/React.createElement(ProductListPagerClassicDots, {
    className: classes.dots
  }) : null, showLastPage === true ? /*#__PURE__*/React.createElement(ProductListPagerClassicPaginationButton, {
    className: classes.sideButton,
    pageIndex: count - 1,
    onChangePage: onChangePage,
    currentPage: page
  }) : null, showNextPage === true ? /*#__PURE__*/React.createElement(ProductListPagerClassicArrow, {
    onArrowClick: handleArrowClick(),
    buttonArrowContent: buttonRightArrowContent,
    className: classes.arrow
  }) : null)) : null);
}

ProductListPagerClassic.propTypes = {
  backIconButtonProps: PropTypes.node,
  buttonWidth: PropTypes.number,
  classes: PropTypes.shape({
    arrow: PropTypes.string,
    dots: PropTypes.string,
    'full-width': PropTypes.string,
    leftSide: PropTypes.string,
    pageList: PropTypes.string,
    paginationButton: PropTypes.string,
    rightSide: PropTypes.string,
    root: PropTypes.string,
    sideButton: PropTypes.string
  }),
  className: PropTypes.string,
  count: PropTypes.number.isRequired,
  fullWidth: PropTypes.bool,
  nextIconButtonProps: PropTypes.node,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pageListWidthProp: PropTypes.number
};
ProductListPagerClassic.defaultProps = {
  backIconButtonProps: undefined,
  buttonWidth: undefined,
  classes: undefined,
  className: undefined,
  fullWidth: undefined,
  nextIconButtonProps: undefined,
  pageListWidthProp: 0
};
export default ProductListPagerClassic;